import { Injectable } from '@angular/core';
import { Capacitor, Plugins } from '@capacitor/core';
import {
  AlertController,
  ModalController,
  App,
  Platform,
  IonicApp,
  LoadingController,
} from 'ionic-angular';
import { UserProvider } from '../user/user';
import { CrudApiProvider } from '../crud-api/crud-api';
import * as $ from 'jquery';
import * as _ from 'lodash';
import * as debug from 'debug';
import * as moment from 'moment';
import 'rxjs/add/operator/map';
import { Shake } from '@ionic-native/shake';
import { EventEmitter } from '../../includes/eventEmitter';
import { EnvVariables } from '../../environments/environment';
import * as qString from 'query-string';
import { SettingsProvider } from '../settings/settings';
import { ConfigProvider } from '../config/config';
import { ContentToolsProvider } from '../content-tools/content-tools';
import { Browser } from '@capacitor/browser';
import { DeepLinkType } from './tools.types';
import { Device } from '@capacitor/device';
import { Clipboard } from '@capacitor/clipboard';
// import { TripService } from '../trip-service/trip-service';

const { NativeAppRating } = Plugins;
const emailRegex =
  /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/gi;
window['_Plugins'] = Plugins;
window['_Browser'] = Browser;

declare const grecaptcha: any;
declare let CmKit: any;

@Injectable()
export class ToolsProvider extends EventEmitter {
  log = debug('tools:ToolsProvider');

  private _storedEvents = [];

  user: any;
  shakeListen = false;
  badgesPromise;
  serverDown: any = false;
  serverDownInterval;
  hasFocus = true;
  activeToast;
  pingErrorCount = 0;
  playingVideos = [];
  mainAppController;
  weather = {};
  showDrawer = false;
  isWeb = false;
  isMobileWeb = false;

  // circular dependency, so set there
  onboarding;

  constructor(
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public userProvider: UserProvider,
    public crudApiProvider: CrudApiProvider,
    public modalCtrl: ModalController,
    public appCtrl: App,
    public env: EnvVariables,
    private shake: Shake,
    public settingsProvider: SettingsProvider,
    public config: ConfigProvider,
    public contentTools: ContentToolsProvider,
    public platform: Platform
  ) {
    super();

    this.webUI();

    this.contentTools.tools = this;
    this.user = this.userProvider.info;
    this.settingsProvider.tools = this;

    // circular dependency, userProvider user can't include it
    this.userProvider.tools = this;

    this.log('init');

    setInterval(() => {
      this.flushEvents();
    }, 3000);

    this.startShake();

    window.addEventListener('blur', () => {
      this.hasFocus = false;
    });

    window.addEventListener('focus', () => {
      setTimeout(() => {
        this.hasFocus = true;
      }, 5000);
    });
  }

  async webUI() {
    const webPlatform = Capacitor.getPlatform() === 'web';
    const info = await Device.getInfo();
    const windowsOrMac =
      info.operatingSystem === 'windows' || info.operatingSystem === 'mac';
    console.warn('is web', Capacitor.getPlatform(), info);

    if (webPlatform && windowsOrMac) {
      this.isWeb = true;
      document.body.classList.add('is-web');
      return 'web';
    } else if (webPlatform) {
      this.isMobileWeb = true;
      return 'mobile';
    }
  }

  async killSubs(subs: any[]) {
    try {
      _.each(subs, s => {
        if (s instanceof Function) {
          s();
        } else if (s.unsubscribe) {
          s.unsubscribe();
        }
      });
    } catch (e) {}
  }

  async openStore() {
    const iTunes = 'https://itunes.apple.com/us/app/cdllife/id1407032419?mt=8';
    const googlePlay =
      'https://play.google.com/store/apps/details?id=mobile.cdllife.com';
    const info = await Device.getInfo();

    await this.copyTurnkey();

    this.log('platform: ', this.platform.is('iphone'));
    if (info.operatingSystem === 'ios') {
      window.open(iTunes);
    } else if (info.operatingSystem === 'android') {
      window.open(googlePlay);
    } else {
      window.open(googlePlay);
    }
  }

  async copyTurnkey() {
    const turnkey = localStorage.getItem('APP_AUTH_KEY');
    const cmaString = 'cma=' + JSON.parse(turnkey);
    if (turnkey && this.config.get('mobile-web-cma')) {
      const cmaAuth = await this.crudApiProvider.simpleLocalEncrypt(cmaString);
      await Clipboard.write({
        string: cmaAuth,
      });
    }
  }

  async checkUsersPushNotificationSettings(id, pushType) {
    //commentsReplies,
    //engagements,
    //mentions,
    //messages
    //friendRequests,    X

    let userToCheck;
    let notificationTypes;
    let setting;

    await this.crudApiProvider.get(`/api/users/${id}`).then(res => {
      userToCheck = res.data;
      notificationTypes = userToCheck.settings.pushNotifications;
      setting = notificationTypes[pushType];
    });
    return setting;
  }

  calcTripDistance(route) {}

  getDeepLinkConfig(dlType: string): DeepLinkType {
    const deepLinks = this.config.get('deepLinksMap') || {
      dl: {
        component: 'externalLink',
        tab: 0,
      },
      highwayHunt: {
        component: 'externalLink',
        tab: 2,
      },
      external: {
        component: 'externalLink',
        tab: 0,
      },
      jobs: {
        tab: 3,
      },
      posts: {
        component: 'CommunityPostsPage',
        tab: 0,
        params: ['post_id'],
      },
      post: {
        component: 'CommunityPostsPage',
        tab: 0,
        params: ['post_id'],
      },
      weather: {
        component: 'WeatherPage',
        tab: 2,
        params: [],
      },
      leaderboard: {
        component: 'LeaderboardPage',
        tab: 2,
        params: [],
      },
      roadside: {
        component: 'WreckersFeedPage',
        tab: 2,
        params: [],
      },
      maps: {
        component: 'PlanARoutePage',
        tab: 2,
        params: ['mode'],
      },
      friends: {
        tab: 1,
        args: [],
      },
      'friends-message': {
        component: 'FriendsMessagePage',
        tab: 1,
        args: ['conversation_id'],
      },
      chat: {
        component: 'ChatPage',
        tab: 0,
        args: ['conversation_id'],
      },
      article: {
        tab: 0,
      },
      notifications: {
        tab: 4,
      },
      explore: {
        tab: 2,
      },
      contacts: {
        tab: 1,
        args: [],
      },
    };
    return _.get(deepLinks, dlType);
  }

  getServiceTags() {
    return [
      'roadsideService',
      'loadTransfers',
      'craneService',
      'mobileFueling',
      'forklifts',
      'trailerService',
      'lockOuts',
      'equipmentRepair',
      'jumpStarts',
      'tireRepair',
      'recovery',
      'busService',
      'heavyDutyTowing',
      'lightDutyTowing',
      'speeding',
      'recklessDriving',
      'followingTooClose',
      'laneViolations',
      'accidents',
      'controlLaw',
      'railroadCrossingViolations',
      'failureToPossessCDL',
      'overweight',
      'overLength',
      'overHeight',
      'stopSigns',
      'drivingTooFastForConditions',
      'laneChangeViolations',
      'redLights',
      'logbook',
      'parkingTickets',
      'equipmentViolations',
      'failingToYield',
      'allMovingAndNon-MovingViolations',
      'existingCitations',
      'moving,Non-MovingAndSeriousViolations',
      'stopSignsAndRedLights',
      'fuel &MaintenanceDiscounts',
      'speedingAndRecklessDriving',
      '25%OffFeesForOtherLegalMatters',
      'driverRewardsAndSpousalBenefits',
      'fundInvoicesFast',
      'sameDayFactoring',
      'noStartupFees',
      'noHiddenFees',
      'quickApproval',
      'lowRates',
      'fuelAdvances',
      'friendlyService',
      'usdotNumber',
      'brokerLicense',
      'fmcsaFiling',
      'mcNumber',
      'ucrPermit',
      'boc3Filing',
      'authorityLetter',
      'optionalAddOns',
      'bocFiling',
      'sampleContracts',
    ];
  }

  pingCheck() {
    const self = this;
    let alreadyDone = false;

    if (!document.hasFocus()) {
      return self.log('no focus');
    }

    this.crudApiProvider.get('/ping.json').then(
      res => {
        this.pingErrorCount = 0;
        clearInterval(this.serverDownInterval);
        done();
      },
      e => {
        this.log('error in ping get', e);
        done(e);
      }
    );

    setTimeout(() => {
      done('timeout');
    }, 5000);

    function done(e?) {
      if (alreadyDone) {
        return;
      }
      if (e && !document.hasFocus()) {
        return;
      }

      alreadyDone = true;

      if (e) {
        self.pingErrorCount++;
        self.log('ping error', e, self.pingErrorCount);
        if (!self.serverDown) {
          self.defaultAlert(
            `We're having trouble connecting to CDLLife right now. Please try again later.`
          );

          self.serverDown = $('<div></div>')
            .addClass('ServerDown')
            .html(`We're having trouble connecting to CDLLife right now.`);

          $('body').append(self.serverDown);
        }

        self.log('ping self serverDownInternval', self.serverDownInterval);
        if (!self.serverDownInterval) {
          // now we check every second
          self.emit('pingError', true);
          clearInterval(self.serverDownInterval);
          self.serverDownInterval = setInterval(() => {
            self.log('ping 1s', self.serverDownInterval);
            self.pingCheck();
          }, 1000);
        }
      } else {
        setTimeout(() => {
          if (self.serverDown) {
            self.serverDown.remove();
            self.serverDownInterval = null;
          }
          self.serverDown = false;
          self.emit('pingError', false);
          self.log('ping okay', self.serverDownInterval);
          clearInterval(self.serverDownInterval);
        }, 1000);
      }
    }
  }

  defaultAlert(s?, opts?) {
    const alert = this.alertCtrl.create(
      _.merge(
        {
          title: 'Uh Oh!',
          message: s || "It appears something isn't working right",
          buttons: [
            {
              text: 'OK',
              cssClass: 'alert-button-ok',
              handler: () => {},
            },
          ],
          cssClass: 'alert-title',
        },
        opts
      )
    );
    alert.present();

    setTimeout(() => {
      alert.dismiss();
    }, 20000);
  }

  doesStringContainBlockedStrings(s) {
    let containsInvalidString = false;
    const invalidStrings = ['cdllife', 'cdlife'];
    _.each(invalidStrings, v => {
      if (_.includes(_.lowerCase(s), v)) {
        containsInvalidString = true;
      }
    });
    return containsInvalidString;
  }

  validURL(val): boolean {
    var str = String(val),
      re = new RegExp(
        '^((http|https|ftp)://)?[a-zA-Z0-9-.]+.' +
          '[a-zA-Z]{2,3}(:[a-zA-Z0-9]*)?/?' +
          "([a-zA-Z0-9-._?,'/\\+&amp;%$#=~])*$"
      ),
      re2 = new RegExp('((http|https|ftp)(://)?)$'),
      t1 = re.test(str) && str.match(/\.[a-z]/i),
      t2 = re2.test(str);

    return t1 && !t2;
  }

  validURLStrict(val): boolean {
    var str = String(val),
      re = new RegExp(
        '^((http|https|ftp)://)?[a-zA-Z0-9-.]+.' +
          '[a-zA-Z]{2,3}(:[a-zA-Z0-9]*)?/?' +
          "([a-zA-Z0-9-._?,'/\\+&amp;%$#=~])*$"
      ),
      re2 = new RegExp('((http|https|ftp)(://)?)$'),
      t1 =
        re.test(str) &&
        str.match(/\.[a-z][a-z]+/i) &&
        (str.match(/\.com/i) || str.match(/http/)),
      t2 = re2.test(str);

    return t1 && !t2;
  }

  validEmail(e): boolean {
    const re =
      /^([\w\-\.\+]+)@((\[([0-9]{1,3}\.){3}[0-9]{1,3}\])|(([\w\-]+\.)+)([a-zA-Z]{2,4}))$/;
    return re.test(String(e).toLowerCase());
  }

  validPhoneNumber(e): boolean {
    const re =
      /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
    return re.test(String(e));
  }

  emailInString(testUrl: string, multiple = false, trimEnd = false) {
    let strings = multiple
      ? testUrl
          .split(/(\s)+/)
          .map(d => d.trim())
          .filter(d => d)
      : _.split(testUrl, ' ');
    let found = '';
    let emails = [];

    _.each(strings, string => {
      if (trimEnd) {
        string = _.trimEnd(string, ',.');
      }

      if (this.validEmail(string)) {
        if (multiple) {
          emails.push(string);
        } else {
          if (found === '') {
            found = string;
          }
        }
      }
    });

    return multiple ? emails : found;
  }

  phoneInString(testUrl: string, multiple = false) {
    let strings = multiple
      ? testUrl
          .split(/(\s)+/)
          .map(d => d.trim())
          .filter(d => d)
      : _.split(testUrl, ' ');
    let found = '';
    let phoneNumbers = [];

    _.each(strings, string => {
      if (this.validPhoneNumber(string)) {
        if (multiple) {
          phoneNumbers.push(string);
        } else {
          if (found === '') {
            found = string;
          }
        }
      }
    });

    return multiple ? phoneNumbers : found;
  }

  urlInString(testUrl: string, multiple = false, trimEnd = false) {
    let found = '';
    let urls = [];
    let strings = testUrl
      .split(/(\s)+/)
      .map(d => d.trim())
      .filter(d => d);

    _.each(strings, string => {
      if (trimEnd) {
        string = _.trimEnd(string, ',.');
      }

      if (this.validURLStrict(string) && !string.match(emailRegex)) {
        if (multiple) {
          urls.push(string);
        } else {
          if (found === '') {
            found = string;
          }
        }
      }
    });

    return multiple ? urls : found;
  }

  logEventAndFlush(category, action?, metadata: any = {}, opts?) {
    this.logEvent(category, action, metadata, opts);
    this.flushEvents();
  }

  postImpression(postId) {
    let impressions: any =
      JSON.parse(localStorage.getItem('CDLLIFE_POST_IMPRESSIONS')) || {};

    _.set(impressions, `${postId}`, {
      count: (_.get(impressions, `${postId}.count`) || 0) + 1,
      lastSeen: moment().toISOString(),
    });

    this.log('POST Impression', postId);
    localStorage.setItem(
      'CDLLIFE_POST_IMPRESSIONS',
      JSON.stringify(impressions)
    );
  }

  postEngagement(postId) {
    let engagements: any =
      JSON.parse(localStorage.getItem('CDLLIFE_POST_ENGAGEMENTS')) || {};

    _.set(engagements, `${postId}`, {
      count: (_.get(engagements, `${postId}.count`) || 0) + 1,
      lastSeen: moment().toISOString(),
    });

    this.log('POST Engagement', postId);
    localStorage.setItem(
      'CDLLIFE_POST_ENGAGEMENTS',
      JSON.stringify(engagements)
    );
  }

  getPostImpressions() {
    let MAX = 900;
    let impressions: any =
      JSON.parse(localStorage.getItem('CDLLIFE_POST_IMPRESSIONS')) || {};

    _.each(impressions, (i, k) => {
      const daysToSubtract = moment().subtract(3, 'days');
      const timestamp = moment(i.lastSeen);
      if (daysToSubtract.diff(timestamp, 'days') > 0) {
        delete impressions[k];
      }
    });

    if (_.size(impressions) > MAX) {
      let sortedIds = _.sortBy(_.keys(impressions), d => {
        return new Date(impressions[d].lastSeen);
      }).reverse();
      sortedIds = sortedIds.slice(0, MAX);
      let orig = impressions;
      impressions = {};
      _.each(sortedIds, id => {
        impressions[id] = orig[id];
      });
    }

    localStorage.setItem(
      'CDLLIFE_POST_IMPRESSIONS',
      JSON.stringify(impressions)
    );
    return impressions;
  }

  getPostEngagements() {
    let MAX = 900;
    let engagements: any =
      JSON.parse(localStorage.getItem('CDLLIFE_POST_ENGAGEMENTS')) || {};

    _.each(engagements, (i, k) => {
      const daysToSubtract = moment().subtract(3, 'days');
      const timestamp = moment(i.lastSeen);
      if (daysToSubtract.diff(timestamp, 'days') > 0) {
        delete engagements[k];
      }
    });

    if (_.size(engagements) > MAX) {
      let sortedIds = _.sortBy(_.keys(engagements), d => {
        return new Date(engagements[d].lastSeen);
      }).reverse();
      sortedIds = sortedIds.slice(0, MAX);
      let orig = engagements;
      engagements = {};
      _.each(sortedIds, id => {
        engagements[id] = orig[id];
      });
    }

    localStorage.setItem(
      'CDLLIFE_POST_ENGAGEMENTS',
      JSON.stringify(engagements)
    );
    return engagements;
  }

  openDrawer() {
    this.showDrawer = true;
  }

  closeDrawer() {
    this.showDrawer = false;
  }

  logAnalyticsEvent(title, subtitle, metadata?) {
    const logcpix = debug('cpix:logAnalyticsEvent');

    if (
      !_.includes(['default', 'prod'], _.get(this.env, 'environment')) &&
      _.get(this.env, 'forceAnalaytics') !== 'true'
    ) {
      return logcpix(
        'skipping log anayltics in local environment',
        title,
        subtitle,
        metadata,
        _.get(this.env, 'environment')
      );
    }

    if (metadata instanceof Array) {
      metadata = { list: metadata };
    } else if (typeof metadata !== 'object') {
      metadata = {};
      logcpix('metadata arg must be an object');
    }

    try {
      const fbcp = window['facebookConnectPlugin'];
      if (fbcp) {
        fbcp.logEvent(subtitle, metadata || {});
      } else {
      }
    } catch (e) {
      logcpix('FB error thrown: ', e);
    }

    try {
      const cpix: any = window['cpix'];

      let clid = _.get(metadata, 'clid');
      let utms = _.get(metadata, 'utms');

      if (clid) {
        metadata = _.cloneDeep(metadata);
        delete metadata.clid;

        logcpix('logcpix clid', clid);
        cpix.Cookie.setUtm('clid', clid);
      }

      if (utms) {
        logcpix('setting utms', utms);
        this.setUtms(utms);

        delete metadata.utms;
      }

      logcpix('logcpix', subtitle, metadata);

      let header = title;
      let dataInformation = subtitle || metadata || {};

      if (title === 'trackCustom') {
        header = subtitle;
        dataInformation = metadata || {};
      }

      cpix(
        'event',
        header,
        _.merge(
          {
            user: _.get(window, '$user._id'),
          },
          dataInformation
        )
      );

      cpix.Cookie.setUtm('clid', undefined);
      if (utms) {
        setTimeout(() => {
          logcpix('clearing utms');
          this.setUtms({});
        }, 5000);
      }
    } catch (e) {
      // console.error(e);
    }
  }

  logEvent(category, action?, metadata: any = {}, opts?) {
    action = action || category; // in case there isn't a need
    opts = _.merge(
      {
        count: 1,
      },
      opts
    );

    const event = {
      count: opts.count,
      category: category,
      action: action,
      metadata: metadata,
    };

    this._storedEvents.push(event);
  }

  async loginBlock(message, opts?: { title: string }): Promise<any> {
    opts = _.merge(
      {
        title: 'Sign Up or Log In',
      },
      opts
    );

    if (this.userProvider.get('_id') && !this.userProvider.unauthedUser) {
      return Promise.resolve(true);
    }

    return new Promise(async (resolve, reject) => {
      const openOnboarding = async flow => {
        await this.onboarding.startOnboarding(flow);

        const id = this.userProvider.get('_id');
        if (id && !this.userProvider.unauthedUser) {
          resolve(true);
        } else {
          resolve(false);
        }
      };

      await CmKit.ActionSheet({
        props: {
          templates: {
            title: `
              <div style="text-align:center">
                <div cm-font="Title / 20 Medium"
                     class="cm-Margin--bottom"
                     cm-color="Neutral / Mine Shaft">
                 ${opts.title}
                     </div>
                <div cm-font="Body 16 / Regular"
                     class="cm-Margin--bottom"
                     cm-color="Neutral / Storm Grey">
                 ${message}
                </div>
              </div>
              `,
            button: button => {
              return CmKit.utils.template`
              <div style="text-align:center">
              <button class="cm-Button cm-Button--2"
              @click=${() => {
                openOnboarding('later');
              }}
                      cm-color="Primary / CDLLife Blue">
                Sign Up
              </button>
              &nbsp;
              &nbsp;
              &nbsp;
              &nbsp;
              <button class="cm-Button cm-Button--alternate cm-Button--2"
              @click=${() => {
                openOnboarding('laterLogin');
              }}
                      cm-color="Primary / CDLLife Blue">
                Log In
              </button>
              </div>
            `;
            },
            cancel: `
              <div style="text-align:center"
                    cm-font="Button / 14 Regular"
                    class="cm-Margin--bottom"
                    cm-color="Neutral / Manatee">
                Dismiss
              </div>
              `,
          },
          buttons: [
            {
              // text: opts.cancel,
            },
          ],
        },
      });
    });
  }

  // Maxes a promise take at least the timeout amount of time
  minimumDelay(promise: Promise<any>, timeout) {
    return new Promise((resolve, reject) => {
      let result, error, timedOut, finished;

      promise
        .then(d => {
          result = d;
          finished = true;
          if (timedOut) {
            finish();
          }
        })
        .catch(e => {
          error = e;
          finished = true;
          if (timedOut) {
            finish();
          }
        });

      setTimeout(() => {
        timedOut = true;
        if (finished) {
          finish();
        }
      }, timeout);

      function finish() {
        if (error) {
          reject(error);
        }
        resolve(result);
      }
    });
  }

  formatTimeAgo(date) {
    const fromDate = date;
    let d: any = moment().diff(moment(fromDate, 'YYYY-MM-DD'), 'hours');
    this.log('d', fromDate, d);
    if (d >= 169) {
      d = moment().diff(moment(fromDate, 'YYYY-MM-DD'), 'weeks');
      if (d === 1) {
        d = d.toString() + ' week';
      } else {
        d = d.toString() + ' weeks';
      }
      return d;
    } else if (d >= 24 && d <= 168) {
      d = moment().diff(moment(fromDate, 'YYYY-MM-DD'), 'days');
      if (d === 1) {
        d = d.toString() + ' day';
      } else {
        d = d.toString() + ' days';
      }
      return d;
    } else if (d <= 24) {
      if (d === 1) {
        d = d.toString() + ' hour';
      } else {
        d = d.toString() + ' hours';
      }
      return d;
    }
  }

  userEngagementsOnPost(userEngagements) {
    const response = {
      reported: false,
      shared: false,
      commented: false,
      liked: false,
      disliked: false,
      saved: false,
      poll_vote: false,
    };

    _.each(userEngagements, e => {
      if (e.engagementType === 'REPORT') {
        response.reported = true;
      } else if (e.engagementType === 'SHARE') {
        response.shared = true;
      } else if (e.engagementType === 'COMMENT') {
        response.commented = true;
      } else if (e.engagementType === 'SAVE') {
        response.saved = true;
      } else if (e.engagementType === 'LIKE') {
        if (_.get(e, 'likeInformation.value') >= 1) {
          response.liked = true;
        } else {
          response.disliked = true;
        }
      } else if (e.engagementType === 'POLL_VOTE') {
        response.poll_vote = true;
      }
    });

    return response;
  }

  loadingMessageIfAdmin(content: string) {
    if (this.userProvider.isAdmin()) {
      return {
        content,
      };
    } else {
      return { content: '' };
    }
  }

  openNotification(notification, navCtrl, opts?) {
    // Logic may be different depending on notification type
    const loading = this.loadingCtrl.create(
      this.loadingMessageIfAdmin('handling metadata ...')
    );
    loading.present();
    setTimeout(() => {
      loading.dismiss();
    }, 250);

    this.log('openNotification() |  Type: ', notification);
    console.warn('openNotification() |  Type: ', notification);
    const type = notification.type || _.get(notification, 'metadata.type'),
      friendUser = _.get(notification, 'metadata.user'),
      post = _.get(notification, 'metadata.post'),
      comment = _.get(notification, 'metadata.comment'),
      lcMessage = _.get(notification, 'metadata.lcMessage'),
      lcReply = _.get(notification, 'metadata.lcReply'),
      lcRoomId = _.get(notification, 'metadata.lcRoomId'),
      conversation = _.get(notification, 'metadata.message.conversation');

    console.warn('conversation', conversation);
    this.log('openNotification() | open notification', notification);

    if (type === 'NEAR_PARKING' || type === 'WEIGH_STATION') {
      this.log('opening Near parking/weigh');
      const modal = this.modalCtrl.create('PlaceNotificationPage', {
        place: _.get(notification, 'metadata.place'),
        forceShowOptions: true,
      });
      modal.present();
    } else if (type === 'CUSTOM') {
      let deepLink =
        _.get(notification, 'metadata.message.deepLink') || // todo deprecate (future sending metadata deepLink)
        _.get(notification, 'metadata.deepLink');

      if (!deepLink) {
        this.log('no deep link?');
      }
      const id = this.getDeepLinkId(deepLink);
      if (id) {
        this.navigateToPost(id, navCtrl, { openInFeed: true });
      } else if (deepLink.includes('https')) {
        this.openExternalUrl(deepLink, '_blank');
      } else {
        // TODO navTo
        this.openExternalUrl(deepLink, 'deep-link');
      }

      this.logAnalyticsEvent('trackCustom', 'notification-opened', {
        source: _.get(notification, 'metadata.source'),
        type,
        deepLink,
        user: _.get(notification, 'user'),
      });
    } else if (type === 'USER_VERIFIED') {
      const modal = this.modalCtrl.create('UserProfilePage', {
        user_id: this.userProvider.get('_id'),
        navPush: false,
      });
      modal.onDidDismiss(() => {
        const regex = new RegExp('Leaderboard');
        if (regex.test(_.get(notification, 'metadata.badge.id'))) {
          setTimeout(() => {
            this.appCtrl.getActiveNav().push('LeaderboardPage');
          }, 100);
        }
      });
      modal.present();
    } else if (type === 'BADGE') {
      const modal = this.modalCtrl.create('BadgeDetailPage', {
        badgeId: _.get(notification, 'metadata.badge.id'),
        user: this.userProvider.get(),
        userHasBadge: true,
        navPush: true,
      });
      modal.onDidDismiss(() => {
        const regex = new RegExp('Leaderboard');
        if (regex.test(_.get(notification, 'metadata.badge.id'))) {
          setTimeout(() => {
            this.appCtrl.getActiveNav().push('LeaderboardPage');
          }, 100);
        }
      });
      modal.present();
    } else if (type === 'TRIP_COMPLETE') {
      navCtrl.parent.select(1);
      this.appCtrl.getActiveNav().push('PlanARoutePage', {
        showRouteContinueModal: true,
      });
    } else if (
      type === 'LIKE_A_POST' ||
      type === 'TAGGED_POST' ||
      type === 'USER_TAGGED'
    ) {
      this.log('navToPost');
      if (type === 'USER_TAGGED') {
        const postId =
          _.get(comment, 'post') || _.get(post, 'post') || _.get(post, '_id');
        this.navigateToPost(postId, navCtrl, {
          params: {
            engagement:
              _.get(comment, 'parentComment') || _.get(comment, '_id'),
            navToComments: true,
          },
        });
      } else {
        this.navigateToPost(post._id, navCtrl);
      }
    } else if (type === 'LIKE_A_COMMENT') {
      let eng = _.get(notification, 'metadata.engagement') || {};
      this.log('engagement params: ', {
        engagement:
          eng.engagementType === 'COMMENT' ? eng._id : eng.parentComment,
        navToComments: true,
      });
      this.navigateToPost(comment.post, navCtrl, {
        params: {
          engagement:
            eng.engagementType === 'COMMENT' ? eng._id : eng.parentComment,
          navToComments: true,
        },
      });
    } else if (type === 'COMMENT_A_POST') {
      let eng = _.get(notification, 'metadata.engagement') || {};

      this.log('engagement params: ', {
        engagement:
          eng.engagementType === 'COMMENT' ? eng._id : eng.parentComment,
        navToComments: true,
      });

      this.navigateToPost(post._id, navCtrl, {
        params: {
          engagement:
            eng.engagementType === 'COMMENT' ? eng._id : eng.parentComment,
          navToComments: true,
        },
      });
    } else if (type === 'COMMENT_A_COMMENT') {
      let eng = _.get(notification, 'metadata.engagement') || {};

      this.log('engagement params: ', {
        engagement:
          eng.engagementType === 'COMMENT' ? eng._id : eng.parentComment,
        navToComments: true,
      });
      this.navigateToPost(comment.post, navCtrl, {
        params: {
          engagement:
            eng.engagementType === 'COMMENT' ? eng._id : eng.parentComment,
          navToComments: true,
        },
      });
    } else if (type === 'REPLY_A_REPLY') {
      let eng = _.get(notification, 'metadata.engagement') || {};

      this.log('engagement params: ', {
        engagement:
          eng.engagementType === 'COMMENT' ? eng._id : eng.parentReply._id,
        navToComments: true,
      });
      this.navigateToPost(post, navCtrl, {
        params: {
          engagement:
            eng.engagementType === 'COMMENT' ? eng._id : eng.parentReply._id,
          navToComments: true,
        },
      });
    } else if (
      type === 'REJECTED_CUSTOM_TAG' ||
      type === 'ACCEPTED_CUSTOM_TAG'
    ) {
      let post = _.get(notification, 'metadata.post') || {};
      this.log('navToPost');
      this.navigateToPost(post._id, navCtrl);
    } else if (conversation) {
      // alert('opening conv' + conversation);
      try {
        // TODO navTo
        // this.openExternalUrl(
        //   `/contacts/friends-message/${conversation}`,
        //   'deep-link',
        //   {
        //     setTab: 'messages',
        //   }
        // );
        this.navTo('FriendsMessagePage', 1, {
          conversation_id: conversation,
        });
      } catch (e) {
        // this.log('PushNotif, 1 error', e);
      }
    } else if (lcRoomId) {
      // TODO navTo
      // this.openExternalUrl(`/chat/chat/${lcRoomId}`, 'deep-link');
      this.navTo('ChatPage', 1, {
        conversation_id: lcRoomId,
      });
    } else if (lcMessage || lcReply) {
      // TODO navTo
      // this.openExternalUrl(
      //   `/chat/replies/${lcMessage?._id || lcReply?.messageId}`,
      //   'deep-link'
      // );
      this.navTo('RepliesPage', 1, {
        conversation_id: lcMessage?._id || lcReply?.messageId,
      });
    } else if (friendUser) {
      // alert('friend user');
      // TODO navTo
      // this.openExternalUrl('/contacts/friends', 'deep-link', {
      //   setTab: 'friends',
      // });
      this.navTo('FriendsPage', 3);
    }
    // loading.dismiss();
  }

  getDeepLinkId(deepLink) {
    // /feed/community-posts/5d60741dccf184001f795c1c
    // /feed/home?notification_post=5d60741dccf184001f795c1c
    // if search param 'notification_post', returns post id
    // else just returns.

    if (!_.includes(deepLink, '/feed/')) {
      this.log('no feed', deepLink);
      return;
    }
    const np = _.last(_.split(deepLink, 'notification_post='));
    if (_.includes(np, '/')) {
      return _.last(_.split(np, '/'));
    } else {
      return np;
    }
  }

  // post can be the post or an id
  navigateToPost(post, navCtrl, opts?) {
    const loading = this.loadingCtrl.create(
      this.loadingMessageIfAdmin('navigating to post ...')
    );
    loading.present();
    opts = _.merge({}, opts);
    if (typeof post === 'string') {
      this.crudApiProvider.get(`/api/posts/${post}`).then(
        res => {
          post = res.data;
          if (post) {
            // if (opts.openInFeed) {
            // this.log('opening in feed');
            // this.emit('showNotificationPostInFeed', post);
            // } else {
            try {
              loading.dismiss();
              loading.dismissAll();
            } catch (e) {}
            ready(this.appCtrl);
            // }
          } else {
            const alert = this.alertCtrl.create({
              title: 'Post Not Found',
              message:
                'This post can not be found as the post was deleted by the creator of the post or by the CDLLife Admin Team.',
              buttons: [
                {
                  text: 'Ok',
                  cssClass: 'alert-button-ok',
                  handler: () => {
                    return;
                  },
                },
              ],
              cssClass: 'alert-title',
            });
            alert.present();
            try {
              loading.dismiss();
              loading.dismissAll();
            } catch (e) {}
          }
        },
        e => {
          alert('error finding post');
          try {
            loading.dismiss();
            loading.dismissAll();
          } catch (e) {}
        }
      );
    } else if (typeof _.get(post, 'user') === 'string') {
      const userId = _.get(post, 'user');
      this.getUserObjectById(userId).then(user => {
        post.user = user;
        ready(this.appCtrl);
      });
    } else {
      ready(this.appCtrl);
    }

    function ready(appCtrl) {
      setTimeout(() => {
        try {
          loading.dismiss();
          loading.dismissAll();
        } catch (e) {}
      });
      let page;

      if (post.source === 'COMMUNITY') {
        page = 'CommunityPostsPage';
      } else if (post.type === 'JOB') {
        page = 'IndividualJobPage';
      } else {
        page = 'NewsArticleFullPage';
      }
      try {
        appCtrl.getActiveNav().push(
          page,
          _.merge(
            {
              post: post,
              post_id: post._id,
            },
            opts.params
          )
        );
      } catch (e) {
        try {
          if (!_.get(opts, 'skipTab')) {
            navCtrl.parent.select(1);
          }
          appCtrl.getActiveNav().push(
            page,
            _.merge(
              {
                post: post,
                post_id: post._id,
              },
              opts.params
            )
          );
        } catch (e) {
          try {
            appCtrl.getActiveNav().setRoot('HomePage');
            appCtrl.getActiveNav().push(
              page,
              _.merge(
                {
                  post: post,
                  post_id: post._id,
                },
                opts.params
              )
            );
          } catch (e) {}
        }
      }
    }
  }

  getUserObjectById(userId) {
    return this.crudApiProvider
      .get(`/api/users/${userId}`)
      .then(res => {
        return Promise.resolve(res.data);
      })
      .catch(e => {
        return Promise.reject(`Error fetching user id ${userId}`);
      });
  }

  appendQueryToUrl(link, query) {
    const clone = _.cloneDeep(query),
      qs = qString.parseUrl(link);

    _.each(clone, (v, k) => {
      if (clone[k] === undefined) {
        delete clone[k];
      }
    });

    _.merge(qs.query, query);
    return qs.url + '?' + qString.stringify(qs.query);
  }

  appendUserDataToUrl(link) {
    const regex = /livetrucking.com/,
      regex2 = /.*\.cdllife.com/i,
      highwayHuntRegex = /^https:\/\/highwayhunt.cdllife.com($|\?|\/)/i,
      platform = this.platform.is('android') ? 'android' : 'ios';

    const user = {
      email: this.userProvider.get('email'),
      firstName: this.userProvider.get('firstName'),
      lastName: this.userProvider.get('lastName'),
      jobSearchInfo: this.userProvider.get('jobSearchInfo'),
    };
    this.log('appendUserDataToUrl | user', user);
    this.log('appendUserDataToUrl | might encode', regex.test(link), link);

    // add auth to url if redirecting to hh
    if (highwayHuntRegex.test(link)) {
      const authKey = localStorage.getItem('APP_AUTH_KEY');
      if (authKey) {
        const qs = qString.parseUrl(link);
        qs.query['aid'] = 'mat--' + JSON.parse(authKey);

        if (platform === 'android') {
          qs.query['reload'] = 'true';
        }

        link = qs.url + '?' + qString.stringify(qs.query);
        this.log('appendUserDataToUrl | encoded: ', typeof authKey, link);
      }
    } else if (
      // if liveTrucking add user encoded info to link query
      regex.test(link) ||
      regex2.test(link)
    ) {
      const qs = qString.parseUrl(link);
      qs.query['ai'] = btoa(JSON.stringify(user));
      this.log('appendUserDataToUrl | QUERY: ', qs);
      link = qs.url + '?' + qString.stringify(qs.query);
      this.log('appendUserDataToUrl | encoded: ', link);
    } else {
      // this.log('do nothing', link);
    }

    return link;
  }

  async getNewsArticleFromUrl(url: string) {
    // if (host === 'https://cdllife.com' && _.get(query, 'newsBrowser')) {
    // open internal article if possible
    // delete query.newsBrowser;
    const article = await this.crudApiProvider
      .get('/api/posts/articleUrl', {
        url,
      })
      .catch(e => {
        this.openExternalUrl(url, '_blank', {});
      });

    return _.get(article, 'data');
  }

  openExternalUrlTag(url) {
    if (url) {
      this.logAnalyticsEvent(
        'trackCustom',
        'sponsorship-tracking-tag',
        { 
          url,
          location: 'command-center'
        }
      );
      this.openExternalUrl(url);
    }
  }

  openExternalUrl(link, type = '_blank', query = {}) {
    if (type === 'deep-link') {
      try {
        link = link.replace('/#', '').replace(/^\//, '');
        link = '/' + link;

        const allTabs = this.mainAppController.tabRef.getAllChildNavs(),
          splits = link.split('/').filter(d => d),
          correctTab = _.findIndex(allTabs, t => {
            const splitTitle = _.get(splits, 0);
            const tabTitle = String(t.tabTitle).toLowerCase();
            alert('splitTitle: ' + splitTitle + ' | tabTitle: ' + tabTitle);
            return String(t.tabTitle).toLowerCase() === _.get(splits, 0);
          }),
          nav = this.mainAppController.tabRef.getAllChildNavs()[correctTab],
          segments = nav && nav.linker.getCurrentSegments(link),
          last: any = _.last(segments);

        if (correctTab > -1) {
          this.mainAppController.tabRef.select(correctTab);
        }

        if (last && nav && splits[0] !== splits[1]) {
          nav.push(last.name, _.merge(last.data, this.parseQuery(link), query));
        } else if (last && nav) {
          if (_.get(nav, '_views.length') > 1) {
            // go to the start
            nav.popToRoot();
          }
        }
      } catch (e) {
        console.error('error', e);
      }
      return;
    }

    if (!/:\/\//.test(link)) {
      link = 'http://' + link;
    }

    link = this.appendQueryToUrl(link, query);
    link = this.appendUserDataToUrl(link);

    type = type || '_blank';

    if (type === '_blank') {
      const svc = window['SafariViewController'];

      if (!svc) {
        return fallbackOpen();
      }

      svc.isAvailable(function (available) {
        if (available) {
          svc.show(
            {
              url: link,
              hidden: false,
              animated: true,
              transition: 'curl',
              enterReaderModeIfAvailable: false,
              tintColor: '#FFFFFF', // default is ios blue
              barColor: '#205f96', // on iOS 10+ you can change the background color as well
              controlTintColor: '#ffffff', // on iOS 10+ you can override the default tintColor
            },
            function (result) {
              // this success handler will be invoked for the lifecycle
              // events 'opened', 'loaded' and 'closed'
            },
            function (msg) {
              console.error('Error', msg);
            }
          );
        } else {
          fallbackOpen();
        }
      });
    } else {
      fallbackOpen();
    }

    function fallbackOpen() {
      const splits = link.split('://');
      if (splits.length == 1) {
        splits.unshift('http');
      }
      splits[0] = splits[0].toLowerCase();
      Browser.open({
        url: splits.join('://'),
      });
    }
  }

  openJobs(userId, location = 'default') {
    this.logAnalyticsEvent('trackCustom', 'open-jobs', {
      location,
    });

    const base = 'https://dedicatedjobs.cdllife.com';
    const url = userId
      ? `${base}/api/drivers/${encodeURI('MID|' + userId)}/jobs`
      : 'https://jobs.cdllife.com';

    this.openExternalUrl(url, '_blank', {
      rt: 'mobileApp',
      utm_source: 'cbo-cdllife-mobileApp',
      utm_campaign: `open-jobs-${location}`,
    });
  }

  private flushEvents() {
    try {
      const events = this._storedEvents;
      this._storedEvents = [];

      if (_.size(events)) {
        this.crudApiProvider
          .post('/api/events/batch', {
            events: events,
          })
          .then(
            d => {},
            e => {
              this.log('an error occured logging events', e);
            }
          );
      }
    } catch (e) {
      this.log('an error occured logging events (2)', e);
    }
  }

  startShake() {
    const self = this;

    if (this.userProvider.get('_id')) {
      start();
    } else {
      this.userProvider.on('updated', () => {
        if (!this.shakeListen && this.userProvider.get('_id')) {
          start();
        }
      });
    }

    function start() {
      const email = self.userProvider.get('email');

      if (!/uhray.com/.test(email)) {
        return;
      }

      self.log('shake | listening');
      self.shakeListen = true;

      try {
        self.shake.startWatch(60).subscribe(() => {
          const def = localStorage.getItem('DEFAULT_SHAKE_URL'),
            url = prompt(
              'IP Address + Port (e.g. 10.172.111.55:8100) or branch (e.g. dev)',
              def || ''
            );
          if (url) {
            const origin = location.origin,
              pathname = location.pathname.split('/'),
              fullurl = /[0-9]/.test(String(url)[0])
                ? 'http://' + url
                : `http://d3psokhb5cogyo.cloudfront.net/app/${url}/index.html`;
            pathname.pop();
            window.location.href =
              fullurl +
              '?href=' +
              encodeURIComponent(origin + pathname.join('/'));
            localStorage.setItem('DEFAULT_SHAKE_URL', url);
          }
        });
      } catch (e) {}
    }
  }

  getBadges() {
    if (this.badgesPromise) {
      return this.badgesPromise;
    }

    return (this.badgesPromise = this.crudApiProvider.get('/api/badges'));
  }

  sortAdsByWeight(ads) {
    this.log('sorting ads');

    if (!_.size(ads)) {
      return [];
    }

    // We will make a list 50 long.
    // Each time through, we grab one based on the weighting
    // So, it could end up with 3fb ads in a row or something.
    //
    // The only caveat here is we will not do two of the same direct ad
    // in a row

    const list = [];

    while (list.length < 50) {
      list.push(this.pickOneAd(ads, _.last(list)));
    }

    return list;
  }

  pickOneAd(ads, last?) {
    const scores: any = {};
    const sorted = _.sortBy(ads, a => {
      if (scores[a._id]) {
        return scores[a._id];
      }

      const s = Math.random() * _.get(a, 'adInformation.weight', 1);

      scores[a._id] = s;

      return s;
    });

    let choice = sorted.pop();

    if (
      last &&
      _.get(choice, 'adInformation.adSource') === 'DIRECT_AD' &&
      choice._id === last._id
    ) {
      choice = sorted.pop();
    }

    return choice;
  }

  checkCanMessage() {
    const pref = this.userProvider.get('userMessagePref');
    const isAdmin = this.userProvider.info.role;

    if (pref !== 'nobody' || isAdmin === 'admin') {
      this.log('friends error: in here', pref);
      return new Promise((resolve, reject) => {
        return resolve(true);
      });
    } else {
      return new Promise((resolve, reject) => {
        const alert = this.alertCtrl.create({
          title: 'Message Preferences',
          message:
            'In order to send a message, you need to allow friends to message you.',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              cssClass: 'alert-button-cancel',
              handler: () => {
                return resolve(false);
              },
            },
            {
              text: 'Allow',
              cssClass: 'alert-button-confirmatory',
              handler: () => {
                this.userProvider
                  .crudUpdate({
                    userMessagePref: 'friends',
                  })
                  .then(
                    () => {
                      return resolve(true);
                    },
                    e => {
                      return resolve(true);
                    }
                  );
              },
            },
          ],
          cssClass: 'alert-title',
        });
        alert.present();
      });
    }
  }

  hasSeenIntro(type) {
    const testing = localStorage.getItem('TESTING_WALKTHROUGH');

    if (testing == type) {
      return false;
    }

    return !!this.userProvider.get(`stats.events.${type}Intro`);
  }

  markSeenIntro(type) {
    if (this.userProvider.get('_id')) {
      this.logEventAndFlush(`${type}Intro`);
      this.log('setting ', `stats.events.${type}Intro`);
      _.set(this.userProvider.info, `stats.events.${type}Intro`, 1);
    }
  }

  customToast(msg, duration = 3000, cl?) {
    this.removeToast();

    const div = $(`<div></div>`).addClass('CustomToast').html(msg);

    if (cl) {
      div.addClass(cl);
    }
    this.activeToast = div;

    $('ion-app').append(div);

    $(div).click(() => {
      this.removeToast();
    });

    setTimeout(() => {
      this.removeToast();
    }, duration);
  }

  removeToast() {
    $(this.activeToast).remove();
    this.activeToast = null;
  }

  // make a phone call
  callPhone(p) {
    //  href="tel:{{job.cdlPhone | formatHrefTel}}"
    p = getHref(p);
    const cn = _.get(window, 'plugins.CallNumber.callNumber');
    if (cn) {
      cn(
        () => {},
        () => {},
        p,
        true
      );
    } else {
      window.open(`tel:${getHref(p)}`, '_system');
    }

    function getHref(value) {
      let v = String(value || '').replace(/ /g, '');
      let ext = v.match(/x\d+$/);
      let numbers = v.replace(/x\d+$/, '').replace(/\D/g, '');
      let cTen = { 0: '', 3: '-', 6: '-' };
      let cSeven = { 3: '-' };
      let i;
      let result = '';

      if (numbers.length == 11 && numbers[0] == '1') {
        numbers = numbers.slice(1);
      }

      if (numbers.length == 10) {
        result = '+1-';
        for (i = 0; i < numbers.length; i++) {
          result += (cTen[i] || '') + numbers[i];
        }
      } else if (numbers.length == 7) {
        for (i = 0; i < numbers.length; i++) {
          result += (cSeven[i] || '') + numbers[i];
        }
      } else result += numbers;

      return result; //ignoring extensions in tel
    }
  }

  copyToClipboard(str) {
    this.log('copying');
    // if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
    if (Capacitor.getPlatform() === 'ios') {
      const el = <any>document.createElement('textarea'); // Create a <textarea> element
      el.value = str; // Set its value to the string that you want copied
      el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof
      el.style.position = 'absolute';
      el.style.left = '-9999px'; // Move outside the screen to make it invisible
      document.body.appendChild(el); // Append the <textarea> element to the HTML document
      const range = document.createRange();

      el.contentEditable = true;
      el.readOnly = false;
      range.selectNodeContents(el);

      const s = window.getSelection();
      s.removeAllRanges();
      s.addRange(range);

      el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

      document.execCommand('copy');
      setTimeout(() => {
        document.body.removeChild(el); // Remove the <textarea> element
      });
    } else {
      const el = document.createElement('textarea'); // Create a <textarea> element
      el.value = str; // Set its value to the string that you want copied
      el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof
      el.style.position = 'absolute';
      el.style.left = '-9999px'; // Move outside the screen to make it invisible
      document.body.appendChild(el); // Append the <textarea> element to the HTML document
      const selected =
        document.getSelection().rangeCount > 0 // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0) // Store selection if found
          : false; // Mark as false to know no selection existed before
      el.select(); // Select the <textarea> content
      document.execCommand('copy'); // Copy - only works as a result of a user action (e.g. click events)
      document.body.removeChild(el); // Remove the <textarea> element
      if (selected) {
        // If a selection existed before copying
        document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
        document.getSelection().addRange(selected); // Restore the original selection
      }
    }
  }

  getPostIdfromUrl(url) {
    const root = 'https://m.cdllife.com/post/';

    if (_.startsWith(url, root)) {
      let postId = _.join(_.slice(url, _.size(root), 24 + _.size(root)), '');
      this.log('postId: ', postId);
      const regex = /^[0-9a-zA-Z]+$/;
      if (postId.match(regex)) {
        return postId;
      }
      return '';
    }
    return '';
  }

  // TODO
  openWeatherLocation(info) {
    const coords = [_.get(info, 'coord.Lon'), _.get(info, 'coord.Lat')];
    this.openExternalUrl(
      `https://darksky.net/forecast/${coords[1]},${coords[0]}/us12/en`
    );
  }

  videoPlaying(v) {
    if (_.includes(this.playingVideos, v)) {
      return;
    }
    this.pauseAllVideos();
    this.playingVideos.push(v);
  }

  pauseAllVideos() {
    this.log('pausing all videos');
    _.each(this.playingVideos, v => {
      try {
        v.pause();
      } catch (e) {}
    });
    this.playingVideos = [];
  }

  pauseVideo(v) {
    if (_.includes(this.playingVideos, v)) {
      _.pull(this.playingVideos, v);
    }
  }

  getGiphyTrending() {
    return new Promise((res, rej) => {
      var xhr = $.get(
        `https://api.giphy.com/v1/gifs/trending?` +
          `&api_key=${_.get(this.env, 'giphyApiKey')}` +
          `&limit=12}`
      );
      xhr.done(function (data) {
        res(data);
      });
    });
  }

  getGiphy(searchString, opts) {
    return new Promise((res, rej) => {
      if (!searchString || !_.get(opts, 'limit') || !_.get(opts, 'limit')) {
        this.customToast('No search provided', 3000);
        return;
      }
      const offset = _.get(opts, 'page') * _.get(opts, 'limit');
      var xhr = $.get(
        `https://api.giphy.com/v1/gifs/search?` +
          `q=${searchString}` +
          `&api_key=${_.get(this.env, 'giphyApiKey')}` +
          `&limit=${_.get(opts, 'limit')}` +
          `&offset=${offset}`
      );
      xhr.done(function (data) {
        res(data);
      });
    });
  }
  getDefaultTrucks() {
    return [
      {
        id: 123,
        title: 'Bobtail',
        maxHeightFt: 13,
        maxHeightIn: 6,
        maxWidthIn: 98,
        trailerLengthFt: 'N/A',
        maxWeight: 22000,
        hazmat: false,
        active: false,
      },
      {
        id: 456,
        title: 'Loaded (Standard)',
        maxHeightFt: 13,
        maxHeightIn: 6,
        maxWidthIn: 102,
        trailerLengthFt: 53,
        maxWeight: 80000,
        hazmat: false,
        active: false,
      },
    ];
  }

  getActiveTruck(): Promise<any> {
    return new Promise(resolve => {
      this.log('getActiveTruck');
      let truckId = JSON.parse(localStorage.getItem('ACTIVETRUCK'));

      let truck = this.getTruckById(truckId);
      if (truck) {
        resolve(truck);
      } else {
        truck = this.getTruckById(456);
        resolve(truck);
      }
    });
  }

  getTruckById(truckId) {
    let trucks = [];
    const originalTrucks = localStorage.getItem('TRUCKS');
    if (originalTrucks) {
      trucks = JSON.parse(originalTrucks);
    }
    trucks = _.union(trucks, this.getDefaultTrucks());

    this.log('getActiveTruck', truckId, trucks);
    if (_.isNumber(truckId) && _.size(trucks)) {
      const r = _.find(trucks, t => {
        return t.id === truckId;
      });
      this.log('returning: ', r);
      return r;
    } else {
      this.log(
        'failed to get active truck. Index ',
        truckId,
        ' originalTrucks ',
        originalTrucks
      );
      return null;
    }
  }

  convertToMeters(value, type) {
    this.log('convertToMeters: ', value, type);
    value = _.toNumber(value);
    if (!_.isNumber(value)) {
      this.log('convertToMeters: not a number', value, type);
      return 0;
    }
    let result = 0;
    if (type === 'ft') {
      result = value / 3.281;
    }
    if (type === 'in') {
      result = value / 39.37;
    }
    this.log('convertToMeters: result', result);
    if (result > 0) {
      return result;
    } else {
      return 0;
    }
  }

  convertToTons(value, type) {
    value = _.toNumber(value);
    if (!_.isNumber(value)) {
      return 0;
    }
    let result = 0;
    if (type === 'pd') {
      result = value / 2000;
    }
    if (type === 'tn') {
      result = value;
    }
    if (result > 0) {
      return result;
    } else {
      return 0;
    }
  }

  getQueryVariable(query, variable) {
    const vars = String(query || '').split('&');
    for (var i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
  }

  parseQuery(queryString) {
    if (/\?/.test(queryString) && queryString[0] !== '?') {
      queryString = queryString.replace(/^.*\?/, '');
    }
    var query = {};
    var pairs = (
      queryString[0] === '?' ? queryString.substr(1) : queryString
    ).split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }

  getStateAbbreviation(fullStateName) {
    const states = [
      { code: 'AL', name: 'Alabama' },
      { code: 'AK', name: 'Alaska' },
      { code: 'AZ', name: 'Arizona' },
      { code: 'AR', name: 'Arkansas' },
      { code: 'CA', name: 'California' },
      { code: 'CO', name: 'Colorado' },
      { code: 'CT', name: 'Connecticut' },
      { code: 'DE', name: 'Delaware' },
      { code: 'DC', name: 'District Of Columbia' },
      { code: 'FL', name: 'Florida' },
      { code: 'GA', name: 'Georgia' },
      { code: 'HI', name: 'Hawaii' },
      { code: 'ID', name: 'Idaho' },
      { code: 'IL', name: 'Illinois' },
      { code: 'IN', name: 'Indiana' },
      { code: 'IA', name: 'Iowa' },
      { code: 'KS', name: 'Kansas' },
      { code: 'KY', name: 'Kentucky' },
      { code: 'LA', name: 'Louisiana' },
      { code: 'ME', name: 'Maine' },
      { code: 'MD', name: 'Maryland' },
      { code: 'MA', name: 'Massachusetts' },
      { code: 'MI', name: 'Michigan' },
      { code: 'MN', name: 'Minnesota' },
      { code: 'MS', name: 'Mississippi' },
      { code: 'MO', name: 'Missouri' },
      { code: 'MT', name: 'Montana' },
      { code: 'NE', name: 'Nebraska' },
      { code: 'NV', name: 'Nevada' },
      { code: 'NH', name: 'New Hampshire' },
      { code: 'NJ', name: 'New Jersey' },
      { code: 'NM', name: 'New Mexico' },
      { code: 'NY', name: 'New York' },
      { code: 'NC', name: 'North Carolina' },
      { code: 'ND', name: 'North Dakota' },
      { code: 'OH', name: 'Ohio' },
      { code: 'OK', name: 'Oklahoma' },
      { code: 'OR', name: 'Oregon' },
      { code: 'PA', name: 'Pennsylvania' },
      { code: 'RI', name: 'Rhode Island' },
      { code: 'SC', name: 'South Carolina' },
      { code: 'SD', name: 'South Dakota' },
      { code: 'TN', name: 'Tennessee' },
      { code: 'TX', name: 'Texas' },
      { code: 'UT', name: 'Utah' },
      { code: 'VT', name: 'Vermont' },
      { code: 'VA', name: 'Virginia' },
      { code: 'WA', name: 'Washington' },
      { code: 'WV', name: 'West Virginia' },
      { code: 'WI', name: 'Wisconsin' },
      { code: 'WY', name: 'Wyoming' },
      { code: 'AB', name: 'Alberta' },
      { code: 'BC', name: 'British Columbia' },
      { code: 'MB', name: 'Manitoba' },
      { code: 'NB', name: 'New Brunswick' },
      { code: 'NL', name: 'Newfoundland and Labrador' },
      { code: 'NS', name: 'Nova Scotia' },
      { code: 'ON', name: 'Ontario' },
      { code: 'PE', name: 'Prince Edward Island' },
      { code: 'QC', name: 'Quebec' },
      { code: 'SK', name: 'Saskatchewan' },
    ];
    if (fullStateName === 'all') {
      return states;
    }
    const shortState = _.find(states, s => {
      return s.name === fullStateName;
    });
    if (shortState) {
      return shortState.code;
    } else {
      return null;
    }
  }

  getBlockUserWarning(name) {
    return "You won't be able to communicate or see each other's posts.";
  }

  recaptchaCheck(action, minScore) {
    const defaultMinScore = 0.5;

    return new Promise((resolve, reject) => {
      grecaptcha.ready(() => {
        grecaptcha
          .execute('6Lf7-asUAAAAALjDu7yPWNgrXC0gcGVhr7YOX9iA', {
            action: action || 'other',
          })
          .then(
            token => {
              $.ajax({
                url: _.get(this.env, 'recaptchaURL'),
                data: {
                  recaptchaToken: token,
                  minScore: minScore || defaultMinScore,
                },
                success: data => {
                  if (_.get(data, 'error')) {
                    return reject(_.get(data, 'error'));
                  } else {
                    const requestScore = parseFloat(
                        _.get(data, 'data.recaptchaResponse.score')
                      ),
                      minimumScore = parseFloat(minScore) || defaultMinScore;
                    let passedCheck = false;

                    if (requestScore > minimumScore) {
                      passedCheck = true;
                    }

                    return resolve({
                      passedAllChecks: passedCheck,
                      minimumScore: minimumScore,
                      remoteIPAddress: _.get(data, 'data.remoteIPAddress'),
                      recaptchaV3Response: _.get(
                        data,
                        'data.recaptchaResponse'
                      ),
                    });
                  }
                },
                dataType: 'json',
              });
            },
            e => {
              return resolve({
                passedAllChecks: false,
                grecaptchaError: true,
                minimumScore: parseFloat(minScore) || defaultMinScore,
                recaptchaV3Response: String(e) || 'Unknown Error',
              });
            }
          );
      });
    });
  }

  validateReviewForDisplay(review) {
    return (
      (_.get(review, 'states.isApproved') === true &&
        _.get(review, 'states.isArchived') !== true) ||
      _.get(review, 'user._id') === this.userProvider.get('_id')
    );
  }

  logTimeSeries(key, item, metric, value = 1) {
    this.crudApiProvider
      .post('/api/timeseries/ads', {
        key,
        item,
        metric,
        value,
      })
      .catch(e => {
        // stifle error
      });
  }

  setUtms(opts: {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_term?: string;
    utm_content?: string;
  }) {
    const cpix: any = window['cpix'];
    cpix.Cookie.setUtm('utm_source', opts.utm_source);
    cpix.Cookie.setUtm('utm_medium', opts.utm_medium);
    cpix.Cookie.setUtm('utm_campaign', opts.utm_campaign);
    cpix.Cookie.setUtm('utm_term', opts.utm_term);
    cpix.Cookie.setUtm('utm_content', opts.utm_content);
  }

  getTrackingParams() {
    const cpix: any = window['cpix'];

    try {
      const p = new cpix.Pixel(),
        keys = p.paramKeys;

      _.each(keys, (v, k) => {
        if (v === undefined) {
          delete keys[k];
        }
      });

      keys.ed = JSON.stringify({
        user: _.get(window, '$user._id'),
      });

      return keys;
    } catch (e) {
      return {};
    }
  }
  isAppVersionNewerThanSecondVersion(v2, v1) {
    const versionOneSplit = _.split(v1, '.'),
      versionTwoSplit = _.split(v2, '.');
    // SEGMENT #1
    if (_.toNumber(versionTwoSplit[0]) > _.toNumber(versionOneSplit[0])) {
      return true;
    }
    if (_.toNumber(versionTwoSplit[0]) < _.toNumber(versionOneSplit[0])) {
      return false;
    }

    // SEGMENT #2
    if (_.toNumber(versionTwoSplit[1]) > _.toNumber(versionOneSplit[1])) {
      return true;
    }
    if (_.toNumber(versionTwoSplit[1]) < _.toNumber(versionOneSplit[1])) {
      return false;
    }

    // SEGMENT #3
    if (_.toNumber(versionTwoSplit[2]) > _.toNumber(versionOneSplit[2])) {
      return true;
    }
    if (_.toNumber(versionTwoSplit[2]) < _.toNumber(versionOneSplit[2])) {
      return false;
    }
    return false;
  }

  setAppZoom() {
    let zoom = parseFloat(this.settingsProvider.get('zoomLevel', '100')) || 100;

    try {
      document.querySelector('[zoomablecss=true]').remove();
    } catch (e) {}

    var element = document.createElement('style'),
      css = `
        cdlc-mobile-post {
          --cdlc-mobile-post-base-font-size: ${_.round(
            (zoom / 100) * 14,
            2
          )}px !important;

          --cdlc-mobile-post-base-line-height: 1.4286 !important
        }
        .ZoomableCSSParent {
          font-size: ${_.round(zoom / 100, 2)}em !important;
        }
        `;

    element.setAttribute('type', 'text/css');
    element.setAttribute('zoomablecss', 'true');

    if ('textContent' in element) {
      element.textContent = css;
    }

    document.getElementsByTagName('head')[0].appendChild(element);
  }

  getCurrentWeather(forceRefresh = false, geolocation?) {
    const self = this;
    return new Promise((resolve, reject) => {
      this.weather = JSON.parse(localStorage.getItem('CDLLIFE_MOBILE_WEATHER'));
      if (!forceRefresh) {
        if (this.weather) {
          this.log('getWeather | returning localStorage', this.weather);
          return resolve(this.weather);
        }
      }

      // force refresh current
      this.log('getWeather | FORCE REFRESH', geolocation);
      if (geolocation) {
        let fallbackHappened = false,
          timeout = setTimeout(() => {
            geolocation.getGeolocationFromIP().then(
              res => {
                fallbackHappened = true;
                geolocation.getRecentLocationPlace(res).then(res => {
                  ready(res);
                });
              },
              e => {}
            );
          }, 2500);
        geolocation.getRecentLocationPlace().then(res => {
          if (fallbackHappened) return;
          clearTimeout(timeout);
          ready(res);
        });
      } else {
        resolve(this.weather);
      }
      function ready(res) {
        const recentStatus = self.userProvider.get('recentStatus');
        const splitName = _.split(res.description, ',');
        const state = (splitName[2] || '').replace(/[0-9]/g, '').trim();
        const stateCode = self.stateCode(state) || '';
        const city = splitName[1] || '';
        let name = stateCode ? city + ', ' + stateCode : city;

        name = String(name).replace(/undefined/g, '');
        self
          .getWeather(
            [_.get(recentStatus, 'longitude'), _.get(recentStatus, 'latitude')],
            {
              route: 'weather',
              nameOverride: name,
              save: true,
            }
          )
          .then(res => {
            resolve((self.weather = res));
          });
      }
    });
  }

  getWeather(coords, opts = {}) {
    const options = _.merge(
      { route: 'weather', save: true, nameOverride: '' },
      opts
    );

    return new Promise((resolve, reject) => {
      this.log('getWeather', coords, _.get(options, 'route'));
      $.ajax({
        url: `https://pro.openweathermap.org/data/2.5/${_.get(
          options,
          'route'
        )}`,
        method: 'GET',
        dataType: 'json',
        data: {
          lat: coords[1],
          lon: coords[0],
          appid: '3abbb8358b57cb42b73f83417e96b36d',
        },
      }).then(res => {
        this.log('getWeather | response', res);
        if (_.get(options, 'nameOverride')) {
          res.name = _.get(options, 'nameOverride') || res.name;
        }
        if (_.get(options, 'route') === 'weather' && _.get(options, 'save')) {
          // set localStorage current weather
          this.log('getWeather | SETTING STORAGE', res);
          localStorage.setItem('CDLLIFE_MOBILE_WEATHER', JSON.stringify(res));
          this.emit('gotWeather', res);
        }
        resolve(res);
      });
    });
  }

  stateCode(state) {
    const states = {
      FED: 'Federal Prison',
      AL: 'Alabama',
      AK: 'Alaska',
      AS: 'American Samoa',
      AZ: 'Arizona',
      AR: 'Arkansas',
      CA: 'California',
      CO: 'Colorado',
      CT: 'Connecticut',
      DE: 'Delaware',
      DC: 'District Of Columbia',
      FM: 'Federated States Of Micronesia',
      FL: 'Florida',
      GA: 'Georgia',
      GU: 'Guam',
      HI: 'Hawaii',
      ID: 'Idaho',
      IL: 'Illinois',
      IN: 'Indiana',
      IA: 'Iowa',
      KS: 'Kansas',
      KY: 'Kentucky',
      LA: 'Louisiana',
      ME: 'Maine',
      MH: 'Marshall Islands',
      MD: 'Maryland',
      MA: 'Massachusetts',
      MI: 'Michigan',
      MN: 'Minnesota',
      MS: 'Mississippi',
      MO: 'Missouri',
      MT: 'Montana',
      NE: 'Nebraska',
      NV: 'Nevada',
      NH: 'New Hampshire',
      NJ: 'New Jersey',
      NM: 'New Mexico',
      NY: 'New York',
      NC: 'North Carolina',
      ND: 'North Dakota',
      MP: 'Northern Mariana Islands',
      OH: 'Ohio',
      OK: 'Oklahoma',
      OR: 'Oregon',
      PW: 'Palau',
      PA: 'Pennsylvania',
      PR: 'Puerto Rico',
      RI: 'Rhode Island',
      SC: 'South Carolina',
      SD: 'South Dakota',
      TN: 'Tennessee',
      TX: 'Texas',
      UT: 'Utah',
      VT: 'Vermont',
      VI: 'Virgin Islands',
      VA: 'Virginia',
      WA: 'Washington',
      WV: 'West Virginia',
      WI: 'Wisconsin',
      WY: 'Wyoming',
    };

    return _.findKey(states, function (s, key) {
      if (s === state) {
        return key;
      }
    });
  }

  resizeImage(img, query) {
    if (/d2z5cdom2mbuj5\.cloudfront/.test(img)) {
      return img + '.resize.jpg?' + query;
    } else {
      return img;
    }
  }

  areReviewsEnabled() {
    let appRatingPromptsConfig = this.config.get('appRatingPrompts');
    let platform = this.platform.is('android') ? 'android' : 'ios';
    return _.get(appRatingPromptsConfig, platform, false);
  }

  async requestReview() {
    let promptEnabled = this.areReviewsEnabled();

    if (this.userProvider.getDaysSinceJoined() >= 7) {
      if (promptEnabled) {
        try {
          await NativeAppRating.rateApp();
        } catch (e) {
          console.error('error requesting NativeAppRating');
        }
      }
    }
  }

  async requestManualReview() {
    try {
      await NativeAppRating.redirectWriteReview();
    } catch (e) {
      console.error('NativeAppRating not available on current device');
    }
  }

  showAdState(v) {
    const adStates = this.config.get('adToggles');
    return _.get(adStates, v, false);
  }

  showDownloadApp() {
    return new Promise<void>(async (resolve, reject) => {
      const info = await Device.getInfo();

      CmKit.ActionSheet({
        props: {
          templates: {
            topIcon: `
              <div>
                <img style="width: 74px" src="assets/imgs/verificationPending.png"
              </div>
            `,
            title: `
            <div style="text-align:center" class="cm-Margin--top cm-Margin--bottom">
              <div cm-font="Title / 20 Medium"
                   class="cm-Margin--bottom"
                   cm-color="Neutral / Mine Shaft">Download the App</div>
            </div>
            `,
            button: button => {
              return CmKit.utils.template`
              <div style="text-align: center">
                  <button
                  class="cm-Margin--top cm-Button cm-Button--1 cm-Width-1-2"
                    cm-color="Primary / CDLLife Blue"
                    @click=${() => {
                      this.openStore();
                    }}>
                    Open ${
                      info.operatingSystem === 'ios' ? 'AppStore' : 'PlayStore'
                    }
                  </button>
                </div>
              `;
            },
            cancel: `
            <div style="text-align: center">
              <button class="cm-Button cm-Button--1 cm-Width-1-2"
                        cm-color="Neutral / Manatee">
                Close
              </button>
            </div>
            `,
          },
          buttons: [{}],
        },
      });
    });
  }

  async navTo(page: string, tab?: number, params?: object, forceTab?: boolean) {
    if (!this.checkAuthentication(page)) return;

    this.handleNav(page, tab, params, forceTab);
  }

  async handleNav(page: string, tab?: number, params?: { id?: string }, forceTab?: boolean) {
    const activeNav = this.appCtrl.getActiveNav();

    this.log('handleNav | ', page, tab, params);
    this.log('handleNav | activeNav', activeNav, this.appCtrl);

    if (!activeNav || !activeNav.id) {
      console.error('Active navigation is undefined.');
      return;
    }

    if (tab && forceTab) {
      this.mainAppController.tabRef.select(tab);
    }

    if (page) {
      try {
        const nav = this.appCtrl.getActiveNav();
        if (nav) {
          nav.push(page, params);
        }
      } catch (error) {
        console.error('Navigation error:', error);
      }

      if (page === 'LegalFeedPage') {
        this.logAnalyticsEvent('trackCustom', 'services-legalServices-click');
      }
    }
  }

  async awaitTimeout(timeout: number = 250) {
    return new Promise(resolve => setTimeout(resolve, timeout));
  }

  //original handle nav function can delete
  // async handleNav(page: string, tab?: number, params?: object) {
  //   setTimeout(() => {
  //     const currentTab = _.parseInt(
  //       _.split(this.appCtrl.getActiveNav().id, 't0-')[1]
  //     );

  //     if ((tab !== currentTab && tab) || tab === 0) {
  //       try {
  //         this.mainAppController.tabRef.select(tab);
  //       } catch (e) {}
  //     }

  //     if (page) {
  //       setTimeout(() => {
  //         if (page === 'LegalFeedPage') {
  //           this.logAnalyticsEvent(
  //             'trackCustom',
  //             'services-legalServices-click'
  //           );
  //         }
  //         setTimeout(() => {
  //           this.appCtrl.getActiveNav().push(page, params);
  //         }, 10);
  //       }, 10);
  //     }
  //   });
  // }

  async handleRoutePlanner() {
    let modal = this.modalCtrl.create('AddTripLocationPage');
    modal.present();
    modal.onDidDismiss(() => {});
  }

  checkAuthentication(key?) {
    if (this.userProvider.userPermission(key)) {
      return true;
    } else {
      this.loginBlock('Create an account to get started.');
      return false;
    }
  }

  taggingWords(string: string) {
    return _.words(string, /[\w@.\S]+|[\r\n]/g);
  }
}



// WEBPACK FOOTER //
// ./src/providers/tools/tools.ts